module.exports = __webpack_public_path__ + "static/img/sangdi.cc30661d.png";